import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
    selector: 'publish-bar',
    templateUrl: './publish-bar.component.html',
    styleUrl: './publish-bar.component.scss'
})
export class PublishBarComponent implements OnInit {
    @Input() hidden: boolean = true;
    @Input() type: string;
    @Output() save = new EventEmitter<void>();
    @Output() discard = new EventEmitter<void>();

    public saveButtonLabel: string;
    public discardButtonLabel: string;

    constructor(public dashboardService: DashboardService,
                private cvLocalizationService: CVLocalizationService) {
    }

    async ngOnInit(){
        await this.cvLocalizationService.GetSection("Responsive_Dashboard");

        if(this.type === "publish"){
            this.saveButtonLabel = this.cvLocalizationService.getCachedText("Responsive_Dashboard", "Publish_Button", "Publish");
            this.discardButtonLabel = this.cvLocalizationService.getCachedText("Responsive_Dashboard", "Revert_Button", "Revert");
        }
        else if(this.type === "template"){
            this.saveButtonLabel = this.cvLocalizationService.getCachedText("Responsive_Dashboard",
                "Save_To_Dashboards", "Save to Dashboards");
            this.discardButtonLabel = this.cvLocalizationService.getCachedText("Responsive_Dashboard", "Exit_Template", "Exit Template");
        }
    }
}
